import React from "react";
import AccountsBaseComponent from "../bases/AccountsBaseComponent/AccountsBaseComponent"
export default function AccountsPage(){ return <AccountsBaseComponent/>; }
